import Vue from 'vue'
import App from '@/App.vue'

import '@/plugins/axiosExtend'
import store from '@/store'

import '@/plugins/routerGuards'
import router from '@/router'

import directive from '@/directive'
import echarts from 'echarts'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

// 全局注册自定义指令
Object.entries(directive)
  .forEach(([key, value]) => void Vue.directive(key, value))

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
